<template>
  <div class="row">
    <form-login
      class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 col-xxl-6 offset-xxl-3"
      :csrf="csrf"
      :position="position"
      :links="links" />
  </div>
</template>

<script>
import formLogin from '../form-login.vue';

export default {
  data: function () {
    return {
      //
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: () => {},
    },
    values: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    formLogin,
  },
  methods: {
    //
  },
  watch: {
    //
  },
  mounted() {
    //
  },
};
</script>
